module.exports = __webpack_public_path__ + "innovation.webp?50ddfe39b649085d71c34536a00111ee";